import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HomePage } from './pages/HomePage';
import { MaintenancePage } from './pages/MaintenancePage';
import { QuotePage } from './pages/QuotePage';
export function App() {
  useEffect(() => {
    document.title = 'The Christmas Palace | Commercial Division';
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-tcp-black text-white font-sans selection:bg-tcp-red selection:text-white" data-id="element-1">
        <Toaster theme="dark" position="top-center" toastOptions={{
        style: {
          background: '#1A1A1A',
          border: '1px solid rgba(255,255,255,0.1)',
          color: '#fff'
        },
        className: 'font-sans'
      }} data-id="element-2" />

        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/maintenance" element={<MaintenancePage data-id="element-7" />} data-id="element-6" />
          <Route path="/quote" element={<QuotePage data-id="element-9" />} data-id="element-8" />
        </Routes>
      </div>
    </BrowserRouter>;
}